// judge-me-product-review-dedupe-20260908-v4-scoped
(function () {
  if (!/^\/products\//.test(window.location.pathname)) return;
  if (window.MaruishiProductReviewDedupe) return;
  window.MaruishiProductReviewDedupe = true;

  var observer;
  var observerActive = true;
  var scheduled = false;
  var hiddenMarker = 'maruishiReviewDedupeHidden';
  var observedReviewRoots = [];

  function reviewBlock(widget) {
    return widget && (widget.closest('.shopify-block.shopify-app-block') || widget);
  }

  function setDedupeHidden(node, shouldHide) {
    if (!node) return;
    if (shouldHide) {
      if (node.dataset[hiddenMarker] === 'true') return;
      node.hidden = true;
      node.dataset[hiddenMarker] = 'true';
      return;
    }
    if (node.dataset[hiddenMarker] !== 'true') return;
    node.hidden = false;
    delete node.dataset[hiddenMarker];
  }

  function dedupeProductReviews() {
    scheduled = false;

    var unifiedReviews = document.getElementById('unified-reviews');
    var fullWidgets = Array.prototype.slice.call(document.querySelectorAll('.jdgm-review-widget'));
    var preferredWidget = fullWidgets.find(function (widget) {
      return widget.closest('#unified-reviews');
    }) || fullWidgets.find(function (widget) {
      var section = widget.closest('.shopify-section');
      return section && /__main$/.test(section.id || '');
    }) || fullWidgets[0];

    fullWidgets.forEach(function (widget) {
      setDedupeHidden(reviewBlock(widget), fullWidgets.length > 1 && widget !== preferredWidget);
    });

    var snippetWidgets = document.querySelectorAll(
      '.jdgm-review-snippet-widget-v2, [data-widget="review-snippet"]'
    );
    snippetWidgets.forEach(function (widget) {
      var isEmptyState = /まだレビューがありません|No reviews yet/i.test(widget.textContent || '');
      var isOutsideUnifiedReviews = !widget.closest('#unified-reviews');
      setDedupeHidden(
        reviewBlock(widget),
        isOutsideUnifiedReviews && isEmptyState && (fullWidgets.length > 0 || Boolean(unifiedReviews))
      );
    });

    var legacyEmptyWidgets = document.querySelectorAll(
      '.spr-container, #shopify-product-reviews, .jdgm-review-widget, ' +
      '.jdgm-review-snippet-widget-v2, [data-widget="review-snippet"]'
    );
    legacyEmptyWidgets.forEach(function (widget) {
      if (!unifiedReviews || widget.closest('#unified-reviews')) return;
      var text = widget.textContent || '';
      var hasEmptyState = /まだレビューがありません|No reviews yet/i.test(text);
      var hasReviewHeading = /Customer Reviews|お客様レビュー/i.test(text);
      if (hasEmptyState && hasReviewHeading) setDedupeHidden(reviewBlock(widget), true);
    });

    observeReviewRoots();
  }

  function scheduleDedupe() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(dedupeProductReviews);
  }

  function observeReviewRoots() {
    if (!observer || !observerActive) return;

    var roots = Array.prototype.slice.call(document.querySelectorAll(
      '#unified-reviews, #judgeme_product_reviews, .jdgm-review-widget, ' +
      '.jdgm-review-snippet-widget-v2, [data-widget="review-snippet"], ' +
      '.spr-container, #shopify-product-reviews'
    ));

    roots.forEach(function (root) {
      var target = reviewBlock(root);
      if (!target || observedReviewRoots.indexOf(target) !== -1) return;
      observedReviewRoots.push(target);
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  var activeReviewScroll = 0;

  function stickyHeaderOffset() {
    var offset = 0;
    var candidates = document.querySelectorAll(
      'header, [id^="shopify-section-header"], .shopify-section-header-sticky'
    );
    candidates.forEach(function (element) {
      var style = window.getComputedStyle(element);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      var rect = element.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 1) return;
      offset = Math.max(offset, rect.bottom);
    });
    return Math.max(0, Math.round(offset));
  }

  function alignLowerReviewWidget(token) {
    if (token !== activeReviewScroll) return;
    var target = document.getElementById('unified-reviews');
    if (!target || target.hidden) return;
    var targetTop = target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: Math.max(0, Math.round(targetTop - stickyHeaderOffset() - 16)),
      behavior: 'auto'
    });
  }

  function startLowerReviewScroll() {
    activeReviewScroll += 1;
    var token = activeReviewScroll;
    [0, 120, 350, 800, 1500, 2600].forEach(function (delay) {
      window.setTimeout(function () {
        alignLowerReviewWidget(token);
      }, delay);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest(
      '.product-info__block-item[data-block-type="rating"] a.rating-badge--link[href="#unified-reviews"]'
    );
    if (!link || !document.getElementById('unified-reviews')) return;
    event.preventDefault();
    startLowerReviewScroll();
  });

  ['wheel', 'touchstart'].forEach(function (eventName) {
    window.addEventListener(eventName, function () {
      activeReviewScroll += 1;
    }, { passive: true });
  });

  document.addEventListener('keydown', function (event) {
    if (/^(Arrow|Page|Home|End| )/.test(event.key)) activeReviewScroll += 1;
  });

  scheduleDedupe();
  document.addEventListener('DOMContentLoaded', scheduleDedupe, { once: true });
  window.addEventListener('load', scheduleDedupe, { once: true });
  document.addEventListener('shopify:section:load', scheduleDedupe);
  document.addEventListener('variant:change', scheduleDedupe);

  observer = new MutationObserver(function (mutations) {
    var hasRelevantChange = mutations.some(function (mutation) {
      return mutation.type === 'childList'
        && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0);
    });
    if (hasRelevantChange) scheduleDedupe();
  });
  observeReviewRoots();
  window.setTimeout(function () {
    if (observer) observer.disconnect();
    observerActive = false;
    observedReviewRoots = [];
    scheduleDedupe();
  }, 15000);
})();
